export const BRACKET_NOT_CLOSED = '括号未闭合'
export const BRACKET_NOT_OPEN = '括号未匹配'

export const QUOTATION_NOT_CLOSED = '引号未闭合'
export const QUOTATION_NOT_OPEN = '引号未匹配'
